import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TransportMethodField } from 'fields';
import { useField } from 'formik';

export default function TransportMethod() {
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'CustomerDetails' });

  const [{ value }, , { setValue }] = useField('addressNumber');

  const handleChange = useCallback(async () => {
    if (value) await setValue('');
  }, [value, setValue]);

  return (
    <TransportMethodField
      name="transportMethod"
      label={t('labels.transportMethod')}
      placeholder={t('placeholders.transportMethod')}
      onChange={handleChange}
    />
  );
}
